var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _polygon, _path10, _ellipse, _path11, _path12, _path13, _path14, _path15, _rect2, _path16, _ellipse2, _path17, _ellipse3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _g2, _polygon2, _polygon3, _path26, _rect3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _line, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _polygon4, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect4, _path49, _ellipse4, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g3, _path57, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolunteer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M753.26,466.92s.09,12.35-5.05,19.81c-.74,1.07-1.62,1.96-2.59,2.67-5.16,3.76-12.96,2.39-16.35-3.65-1-1.78-1.94-4.04-2.65-6.89,0,0-3.62-10.87-17.26-16.83l-12.36-46.45s-.64-1.07,1.92-2.98l14.78-8.95,1.41-.85s4.26-4.9,12.78,.21c0,0,2.74,2.21,6.22,9.16,2.53,5.05,4.31,10.44,5.39,15.99,.94,4.84,2.87,12.65,6.29,18.53,0,0,8.1,9.38,7.46,20.24Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M753.26,466.92s.09,12.35-5.05,19.81c-.74,1.07-1.62,1.96-2.59,2.67l3.16-19.7c2.34-10.87-8.1-20.88-8.1-20.88-7.88-10.44-10.23-27.7-10.23-27.7-5.33-17.26-16.71-17.42-16.71-17.42l-.04-.05,1.41-.85s4.26-4.9,12.78,.21c0,0,2.74,2.21,6.22,9.16,2.53,5.05,4.31,10.44,5.39,15.99,.94,4.84,2.87,12.65,6.29,18.53,0,0,8.1,9.38,7.46,20.24Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M697.65,415.57s3.56-.33,8.76,2.22c6.76,3.32,10.39,10.91,8.54,18.21-.04,.14-.07,.29-.12,.43,0,0-6.1-15.11-17.18-20.87Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M655.68,365.71l-31.96,74.57,47.51-12.14s2.56-3.62,7.24-3.62l8.1-1.49s4.69-5.97,11.08-7.46c0,0,10.44,4.26,18.11,22.8,0,0,5.33,11.08-6.39,23.65,0,0-5.11,3.2-11.72-.21,0,0-51.19,15.82-69.38,24.96,0,0-53.98,24.9-61.87,5.51,0,0-5.54-12.57-4.47-43.04l.21-34.94s-.67-36.16,5.51-25.3l10.26-12.2,60.94-33.03,16.83,21.95Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 607.92,
    y: 464.63,
    width: 15.13,
    height: 18.32,
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M467.11,351.22s.61-.37,.39-1.86c0,0-1.4-.55-2.51-.38,0,0,.23,.69,.41,1.17l1.7,1.07Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M541.47,319.47s-4.69,10.44,5.33,33.88l22.63,56.58c2.03,5.06,3.37,10.37,4.04,15.78,.89,7.23,2.86,18.17,7.11,25.25,.41,.69,.19,1.59-.5,1.99-1.26,.73-2.49,2.42,.25,6.19,.29,.4,.38,.93,.19,1.39-.22,.53-.38,1.36,.06,2.33,.21,.47,.17,1-.11,1.43-.5,.78-.74,3.13,1.71,6.67,0,0,2.98-9.16,15.98-5.33,0,0,13.21,5.11,21.95,5.11,0,0,4.69,0,5.33-3.62,0,0,.96-3.34-4.16-7.14-1.86-1.39-3.09-3.46-3.4-5.76l-6.72-50.8s-2.13-21.09-2.56-30.89l49.01-5.54s47.76-4.96,34.32-65.12l-21.32-19.47-23.01,.64-71.27,5.4-36.97,22.94,2.13,8.1Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M608.59,372.53s-4.47-21.31-18.75-36.43",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M565.63,504.74s-2.95,3.73-1.41,8.5c.59,1.83,2.05,3.25,3.89,3.82,4.2,1.3,13.98,2.42,32.39-4.76,0,0,15.96-6.74,27.17-14.39,1.87-1.27,2.72-3.6,2.14-5.78l-2.04-7.74-20.45,3.84-41.69,16.52Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M513.73,162.36s-16.15,7.54-16.79,18.62l-.21,42.83s-2.56,32.17-7.24,49.01c0,0-3.62,11.08-5.75,32.17l-10.23,65.2,35.16,10.87,18.96-64.56,10.65-58.81,10.44,9.16s-2.98,3.41-2.13,12.14l51.78,16.83,24.72-2.13s19.6-1.28,35.8,4.69l31.82,3.93c2.13,.26,3.83-1.75,3.21-3.8-2.79-9.32-10.94-32.1-28.86-52.97l-15.34-53.69s-7.66-50.34-69.88-55.85l-66.1,26.36Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "485.82 304.68 476.06 307.54 487.14 327.57 493.32 326.08 485.82 304.68",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M487.57,382.33l16.19,59.02s4.26,10.44-7.67,23.22c0,0-14.37,16.45-35.93,14.07-5.44-.6-10.48-3.15-14.14-7.22-.93-1.03-1.93-2.24-2.99-3.65l-34.94-41.55,79.47-43.89Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.14,
    cy: 395.34,
    rx: 48.49,
    ry: 31.26,
    transform: "translate(-136.15 264.61) rotate(-29.02)",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M398.81,393.46s-.01,0-.02,0c-.41,0-.74-.35-.73-.76,0-.14-.13-6.44,2.14-9.17,.03-.04,.07-.08,.11-.11,.03-.02,2.81-2.25,3.79-4.98,.13-.43,1.68-5.51,5.62-11.84,3.72-5.98,10.37-14.2,20.87-19.42,.37-.18,.82-.03,1,.34,.18,.37,.03,.82-.34,1-10.19,5.07-16.65,13.06-20.27,18.88-3.93,6.3-5.45,11.44-5.46,11.49,0,.01,0,.03-.01,.04-1.04,2.94-3.74,5.24-4.21,5.62-1.88,2.31-1.75,8.16-1.75,8.19,0,.41-.34,.73-.74,.73Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M485.98,372.77s9.36-1.41,19.59,6.26l2.3,15.48c.03,.2,.05,.41,.06,.62,.09,1.68,.37,9.43-1.37,17.35-.09,.39-.1,.8-.03,1.2,.12,.66,.26,1.81,.1,2.85-.09,.6-.02,1.2,.22,1.75,.82,1.84,2.32,6.08,.2,8.69,0,0-1.92,1.49-4.47,1.7,0,0,1.92,4.27-.53,5.97l-14.05-50.52s1.18-5.88-2.03-11.35Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M502.59,428.67s-3.41-3.2-3.62-10.44",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M538.28,257.68l-22.19-25.51s-10.01-11.51-12.57-24.29",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M548.16,196.57s7.5,2.77,16.27,1.01c7.12-1.43,12.52-7.29,13.53-14.48,.88-6.3,2.09-16.09-2.64-31.68l-9.8,1.28-17.36,43.87Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 512.77,
    y: 111.29,
    width: 58.95,
    height: 85.73,
    rx: 29.47,
    ry: 29.47,
    transform: "translate(-20.63 123.17) rotate(-12.72)",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M553.62,133.68s-33.99,24.44-48.46,7.35c-1.62-1.91-2.64-4.27-2.95-6.76-.43-3.36-.57-9.05,1.34-16.57,0,0,1.35-5.17,3.03-9.15,.7-1.67,1.28-3.39,1.58-5.18,.06-.36,.17-.73,.35-1.08,.4-.78,.72-1.59,1.03-2.42,.46-1.26,1.34-2.95,2.92-4,1.48-.97,2.81-2.15,3.99-3.47,4.6-5.09,15.53-14.99,26.09-8.16,0,0,31.11-6.61,35.8,20.24l1.5,31.51-10.66,6.21s-12.57,8.74-14.28-.21l-1.28-8.31Z",
    fill: "#231f20",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 575.67,
    cy: 144.33,
    rx: 10.65,
    ry: 6.29,
    transform: "translate(381.19 705.05) rotate(-84.95)",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M485.65,303.28l6.82,26.42,15.97-5.57,1.84,3.34c.9,1.63,2.86,2.36,4.61,1.72l26.59-9.72s10.65-11.08,28.98-11.08c0,0,19.6,2.13,30.89-17.26,0,0,31.11-48.58,42.61-79.05,0,0,8.95-39.2-18.96-41.55,0,0-16.62-3.2-35.16,36.86l-27.42,58.47c-1.03,2.19-2.75,3.98-4.9,5.09-7.67,3.95-27.98,13.84-55.49,22.79,0,0-9.16,1.49-7.43,6.55l-8.95,2.98Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.09,
    cy: 395.07,
    rx: 46.63,
    ry: 29.79,
    transform: "translate(-136.03 264.55) rotate(-29.02)",
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M483.53,398.54l-.55-1.63c-.43-1.29-.53-2.68-.26-4.01s.66-3.04,1.12-4.06c0,0,.86-1.9,1.97-1.04,.23,.18,.39,.44,.48,.72l.6,1.93s-.46,2.25-3.35,8.1Z",
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M483.88,392.9c-.32,0-.61-.2-.71-.53-.12-.39,.1-.81,.49-.93,2.2-.68,2.64-3.85,2.66-4.05,.26-3.52-1.66-5.83-2.82-6.89-.83-.75-1.34-1.74-1.44-2.78-1.63-16.48-6.61-23.42-10.51-26.33-4.08-3.06-7.75-2.41-7.79-2.4-.41,.08-.79-.19-.87-.59s.19-.79,.59-.87c.18-.03,4.36-.77,8.96,2.67,6.01,4.5,9.75,13.72,11.1,27.38,.07,.67,.41,1.32,.96,1.82,1.37,1.25,3.62,3.96,3.3,8.12,0,0,0,.02,0,.03-.02,.18-.51,4.33-3.71,5.33-.07,.02-.15,.03-.22,.03Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M475.91,306.41l-5.49,2.59c-.64,.3-1.31,.55-2,.75l-25.82,7.38s-3.84,1.07-5.54,6.18l-5.77,10.04c-.55,.96-.84,2.04-.84,3.15v8.98c0,1.21,.35,2.39,1,3.41,1.64,2.55,5.06,6.82,8.59,4.67,0,0,1.7-.21,1.07-4.9,0,0,2.34,.64,5.33,.43,0,0,2.34,2.98,9.59,2.77,0,0,6.61,4.9,11.08-.64l-1.7-1.07s-.79-2.57-1.8-3.52c-.06-.05-.05-.14,.01-.19,.36-.26,1.32-1.11,1.36-2.78,0-.06,.05-.12,.11-.12,.37-.03,1.55-.24,1.97-1.52,.03-.08,.12-.11,.19-.06,.41,.31,1.74,.97,4.33-.76,0,0,4.69-.85,5.54-3.84,0,0,7.03-2.98,7.67-6.61l4.51-1.77c.84-.33,1.27-1.27,.97-2.13-1.08-3.02-4.23-10.25-12.28-19.99-.51-.61-1.37-.8-2.09-.47Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M441.12,348.66s-3.41-2.13-3.2-5.97l.43-9.8",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M446.45,349.09s-.85-.43-.85-3.84c0,0,0-3.84-.85-6.18",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M450.28,341.85s2.56,3.41,2.98,5.97c0,0,.64,2.98,2.77,4.05",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M582.29,471.65c.08,2.73-.59,9.6-7.37,19.77,0,0-14.28,14.7-8.74,18.32,0,0,10.44,10.23,47.94-7.46l8.95-6.39s6.82-4.26,4.69-11.51l-4.06-14.6s-1.14,.68-2.37,.82c0,0,1.32,5.25-1.45,5.46,0,0-3.96-.67-7.41-6.19,0,0-7.93-1.69-14.32-4.25,0,0-9.31-3.54-14.87,3.13-.67,.8-1.01,1.83-.98,2.87Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M308.02,300.77s-10.75-23.82-35.26-21.01c0,0-16.1,2.1-22.43,10.24,0,0-15.36-4.71-21.45,3.42-6.09,8.14,.86,38.15-9.65,47.59,0,0,23.74,3.07,40.29-24.34,16.55-27.41,48.5-15.91,48.5-15.91Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.76,310.11c2.62-14.92,8.55-20.53,8.55-20.53,0,0-15.36-4.71-21.45,3.42-6.09,8.14,.86,38.15-9.65,47.59,10.05-.76,19.93-15.56,22.55-30.48Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M343.93,372.05c-.48,0-.95-.25-1.2-.7-24.41-42.9-38.89-72.23-39.03-72.52-.34-.69-.06-1.52,.63-1.85,.69-.34,1.52-.06,1.85,.63,.14,.29,14.59,29.55,38.95,72.37,.38,.66,.15,1.51-.52,1.89-.22,.12-.45,.18-.68,.18Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M363.91,416.07s9.83-28.56,39.1-22.71c0,0,11.47,4.68,15.22,9.36,0,0,7.73-8.19,15.69,.23,7.96,8.43,12.64,21.07,11.47,34.18,0,0-32.07-21.31-42.38-21.31s-39.1,.23-39.1,.23Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.91,402.96c-7.96-8.43-15.69-.23-15.69-.23,0,0,16.62,15.92,27.16,34.42,1.17-13.11-3.51-25.75-11.47-34.18Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.94,499.87c-.2,0-.41-.04-.6-.14-.69-.33-.98-1.16-.64-1.85,.22-.46,22.14-45.83,23.63-66.92,1.5-21.32,2.27-72.75,2.27-73.27,.01-.76,.63-1.36,1.38-1.36,0,0,.01,0,.02,0,.76,.01,1.38,.64,1.36,1.41,0,.52-.77,52.03-2.28,73.42-1.52,21.62-22.99,66.05-23.9,67.93-.24,.49-.73,.78-1.25,.78Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.87,438.53c-.59,0-1.14-.38-1.32-.97-.06-.2-6.4-20.58-12.72-45.49-8.49-33.51-12.89-58.82-13.09-75.24-.46-38.84-2.09-66.15-2.1-66.42-.05-.76,.54-1.42,1.3-1.47,.76-.05,1.42,.54,1.47,1.3,.02,.27,1.65,27.64,2.11,66.56,.46,38.68,25.43,119.13,25.68,119.94,.23,.73-.18,1.51-.91,1.73-.14,.04-.28,.06-.41,.06Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.56,364.56s-2.34-17.79-6.32-29.27c-3.98-11.47-1.87-37.69,17.09-40.39,18.96-2.69,40.5,15.8,47.06,28.68,0,0,26.69-9.02,34.88,6.02,8.19,15.05,3.98,26.28-5.62,27.22-9.6,.94-23.65-31.61-38.63-28.8-14.98,2.81-48.46,36.52-48.46,36.52Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.39,336.25c8.58,8.76,16.29,21.17,22.27,20.59,9.6-.94,13.81-12.17,5.62-27.22-8.19-15.05-34.88-6.02-34.88-6.02l6.99,12.66h0Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.56,461.59c-.67,0-1.26-.49-1.37-1.18-.12-.76,.4-1.46,1.16-1.58,.23-.04,20.37-3.24,30.33-14.98,.5-.58,1.37-.65,1.95-.16,.58,.5,.65,1.37,.16,1.95-10.65,12.54-31.16,15.79-32.03,15.92-.07,.01-.14,.02-.21,.02Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.86,254.41s-23.18-13.7-19.67-40.03c2.97-22.3,12.29-31.26,26.34-32.66,14.05-1.4,23.18,0,23.18,0,0,0,19.47-14.14,38.46-4.19,7.01,3.68,12.33,9.91,15.08,17.33l.9,2.43s-23.18-7.25-33.36,0c0,0,8.72,22.13-3.16,37.23-13.34,16.96-47.76,19.89-47.76,19.89Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.71,181.71s-24.7,12.17-30.08,44.48",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.41,177.66c-3.95-2.11-7.93-3.17-11.76-3.53-11.38,5.08-5.87,23.16-5.87,23.16,10.18-7.25,33.36,0,33.36,0l-.91-2.46c-2.71-7.32-7.94-13.48-14.82-17.16Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.4,513.54h159.82s-14.78-16.51-28.83-10.89c0,0-9.54-14.05-25.49-12.64,0,0-28.59-16.51-49.31,3.51l-6.32,5.05s-15.1-8.57-27.39,5.48c0,0-18.96-2.11-22.48,9.48Z",
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.8,
    cy: 490.76,
    r: 1.76,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.16,498.22c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01,.45-1.01,1.01-1.01,1.01,.45,1.01,1.01Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.47,490.19c0,.87-.71,1.58-1.58,1.58s-1.58-.71-1.58-1.58,.71-1.58,1.58-1.58,1.58,.71,1.58,1.58Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.4,
    cy: 502.31,
    r: 2.11,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.84,497c0,.47-.38,.84-.84,.84s-.84-.38-.84-.84,.38-.84,.84-.84,.84,.38,.84,.84Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.1,
    cy: 502.48,
    r: 1.4,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.86,504.81c0,.51-.41,.92-.92,.92s-.92-.41-.92-.92,.41-.92,.92-.92,.92,.41,.92,.92Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.58 525.13 238.15 525.42 238.46 532.17 227.59 530.68 227.58 525.13",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "225.28 484.82 214.63 524.66 242.11 525.51 262.83 483.12 225.28 484.82",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M207.81,392.77l42.61-20.88s22.8-13.85,43.68,1.49c0,0,8.74,4.9-.43,32.39,0,0-12.39,52.47-21.31,76.92l-47.09,2.13,4.69-21.09-15.98,14.49-54.76-19.6,.85-27.06,47.73-38.78Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 159.62,
    y: 297.37,
    width: 57.95,
    height: 71.59,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01,360.18s3.25,.84,11.77-7.26l-14.28-17.9-5.94,.8-12.38,6.45,8.95,17.68,11.88,.22Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M223.28,346.54l14.14,13.63s2.74,3.03,5.85,2.92c1.14-.04,2.18,.7,2.49,1.8,.68,2.43,2.31,5.87,6.15,6.15l4.9-2.13s15.54-6.06,28.76-.26c0,0,14.71-2.3,19.82-10.39,0,0-14.7,3.62-16.62-8.1,0,0-2.98-11.93,8.74-15.13l-15.87,1.05c-2.3,.15-4.59-.37-6.61-1.49l-9.59-5.36c-1.2-.67-2.28-1.54-3.18-2.58l-24.42-28.05s-17.7-24.65-30.8-26.28c0,0,1.75,4.3,1.25,7.41l8.02,27.19,3.62,38.57,3.33,1.07Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M298.89,333.43c-.83,.72-1.62,1.57-2.02,2.45,0,0-4.69,5.75,4.05,12.78,0,0,9.59,9.16,15.98,2.13h0c3.26-1.56,6.32-3.49,9.13-5.76l1.31-1.06-2.56-4.69s-5.75-.21-2.98-6.18l-10.9-20.18s-4.27,5.82-7.57,14.15c-.97,2.44-2.46,4.64-4.44,6.36Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M195.29,275.65l-3.65,13c-.3,1.07-.26,2.2,.1,3.24l2.42,6.92,8.61,11.37c3.71,6.25,7.34,11.49,7.34,11.49-.43-4.9,.21-13.85,.21-13.85,0,0,2.38-7.52,.03-18.38,0,0-1.61-5.44-1.9-8.29-.01-.15-.02-.3-.02-.45,.02-.97,0-5.09-1.4-8.38,0,0-4.67,2.77-11.76,3.34Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M208.31,279.72s12.71,7.58,13.99,46.36l1.73,41.93s-2.85-6.23-12.09-11.4l-2.38-36.77c-.23-3.52-.02-7.06,.6-10.54,.9-5.01,1.85-13.18,.21-19.87,0,0-1.99-6.43-2.06-9.71Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M203.71,405.27s-3.06,7.72-10.11,18.08c-1.65,2.43-2.84,5.13-3.48,8-1.1,4.91-5.45,14.01-20.69,19.83,0,0,10.53-19.49,17.96-53.86,0,0,6.69,5.11,16.32,7.96Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.81,465.79s-5.57,39.01,33.73,52.51c2.6,.89,5.34,1.33,8.09,1.3,4.38-.05,11.76-.44,19.57-2.19,0,0,1.07,19.39,22.8,32.39l21.66-5.8c3.32-.89,6.72-1.41,10.15-1.56,14.26-.64,55.76-4.81,55.76-31.63,0,0,2.98-22.16-34.09-40.06,0,0-23.18-10.51-35.45-14.1l-102.22,9.14Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 126.84,
    y1: 516.99,
    x2: 167.11,
    y2: 506.55,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M229.97,463.72s2.13-26.42,16.83-43.89",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M136.78,579.92c.14,1.06,.15,2.11,.04,3.14-.53,4.91-3.82,9.24-8.65,10.89-11.67,3.98-24.76-3.25-24.76-3.25-10.04-5.52-9.96-20.25-9.46-26.31,.22-2.65,.19-5.32-.09-7.97-.9-8.62-2.59-10.46-2.59-10.46-4.78-9.68-3.12-15.78-.63-19.33,1.21-1.73,2.62-2.85,3.57-3.48,.69-.46,1.27-1.06,1.73-1.76,1.15-1.79,2.74-3.09,2.74-3.09,2.08,.69,3.88,1.02,3.88,1.02-2.77,7.24,4.9,9.59,4.9,9.59,1.15-.58,2.22-.81,3.04-.88,.9-.09,1.79,.2,2.47,.8,3.74,3.26,11.86,8.21,15.29,10.24,1.08,.64,2.35,.91,3.6,.74,1.98-.27,4.35-.74,4.35-.74l.87,1c-2.12,1.99-2.56,6.75-2.56,6.75,.64,3.84-1.49,8.52-1.49,8.52-2.77,8.15,1.22,17.98,2.81,21.37,.47,1.01,.8,2.08,.95,3.19,0,0,0,.01,0,.02Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M102.55,519.33s7.24,1.28,23.65-1.92c0,0,1.03,11.99,10,21.66l-4.4,.64c-1.29,.19-2.6-.08-3.71-.75-3.53-2.14-11.55-7.09-15.13-10.13,0,0-1.47-1.83-5.51,.09,0,0-7.67-2.13-4.9-9.59Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M120.21,600.93c-26.35,.91-31.08-19.6-31.08-19.6l-1.92-14.7c3.41-7.88-2.77-7.88-2.77-7.88l-4.95-15.23c-.44-1.35-.53-2.78-.25-4.17,2.11-10.36,11.38-12.77,11.38-12.77v.06c-2.48,3.54-4.14,9.65,.64,19.33,0,0,1.69,1.84,2.59,10.46,.28,2.65,.31,5.32,.09,7.97-.5,6.06-.58,20.79,9.46,26.31,0,0,13.09,7.23,24.76,3.25,4.83-1.65,8.12-5.98,8.65-10.89l.02,.02c3.87,8.95-1.9,13.54-7.03,15.76-3.03,1.31-6.3,1.98-9.6,2.09Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.45,528.92s7.24,.64,7.88,9.8c0,0,1.65,12.13-2.14,24.68-.12,.41,0,.86,.31,1.14l1.31,1.18c.19,.17,.44,.27,.7,.28l10.84,.39c.31,.01,.6-.11,.82-.32l3.19-3.19c.2-.2,.31-.46,.32-.74,.09-2.43,.67-14.69,3.47-22.76",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M286.86,563.44c-.4-.65-.81-1.05-1.16-1.3-.45-.32-1.01-.43-1.55-.33-2.36,.45-4.8,2.73-6.12,4.13,0,0,0,0-.02,.03-.84,.89-1.92,1.52-3.11,1.8-6.65,1.55-19.16,.36-19.16,.36-1.7-.21-2.56,.21-2.56,.21l-4.05,3.2-.85-1.49-17.47-6.61c-7.88-3.41-14.28-1.92-14.28-1.92l-9.38,1.49c-10.01,1.07-8.95-2.77-8.95-2.77,.21-6.61,3.75-20.39,3.75-20.39,20.58-4.2,27.95-12.89,27.95-12.89l2.63,1.91c.76,.55,1.77,.59,2.56,.1l.47-.29c.59-.37,.94-1.02,.92-1.72-.3-8.26,5.19-8.26,5.19-8.26,4.26-1.49,5.75,9.38,5.75,9.38,4.47,.85,5.97,7.67,5.97,7.67,2.56,7.46,6.18,10.44,6.18,10.44,3.22,4.4,14.9,7.99,19.57,9.29,2.12,.59,4.05,1.73,5.51,3.37,2.19,2.47,2.19,4.6,2.19,4.6Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M278.01,565.96c-.47,.52-8.15,8.77-19.71,8.77l-28.34,.85s-.64-4.47-3.62-4.05c0,0-1.7,0-4.69,4.9l-22.69-.77c-2.53-.09-4.83-1.61-5.75-3.96-.58-1.48-.67-3.34,.53-5.5l4.47-5.97s-1.07,3.84,8.95,2.77l9.38-1.49s6.39-1.49,14.28,1.92l17.47,6.61,.85,1.49,4.05-3.2s.85-.43,2.56-.21c0,0,12.51,1.18,19.16-.36,1.19-.28,2.27-.91,3.11-1.8Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M258.31,574.73s15.65,.77,24.88-1.38c2.58-.6,4.36-2.94,4.27-5.59-.05-1.34-.21-2.87-.6-4.33,0,0-1.15-1.99-2.7-1.63,0,0-2.41,.08-6.14,4.16,0,0-7.78,8.77-19.71,8.77Z",
    fill: "#c7c8c9",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.71 426.67 311.15 430.7 318.39 408.75 291.38 401.9 283.71 426.67",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M309.92,431.81l7.62,2.08s3.41,7.88,10.87,7.46c0,0,1.7,1.28,3.41,1.7l5,6.85c.61,.84,1.42,1.51,2.37,1.91,1.3,.56,3.25,1.09,5.41,.61,0,0,2.65-.71,1.68-2.6-.08-.15,.09-.31,.24-.24,1.37,.7,4.55,1.93,5.54-1.21,0,0,1.28,1.19,4.32,.05,.87-.32,1.52-1.07,1.75-1.97l1.36-5.27s1.95-2.83,1.74-8.58l2.31,4.11-.85,3.2s4.08,2.29,6.64,.79l2.13-1.92s1.7-1.92,0-4.69l-3.72-9.19c-.28-.7-.65-1.37-1.11-1.98-2.54-3.4-11.64-12.96-32.25-10.14l-12.27-4.27c-2.57-.89-5.42-.57-7.7,.91-2.4,1.55-5.18,4.47-7.3,9.97,0,0-1.68,5.05-.61,8.99,.45,1.67,1.76,2.96,3.43,3.42Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M346.51,449.59l-2.77-4.84s-2.56-3.84-1.7-5.97",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M348.65,430.48l2.06,3.09c.96,1.43,1.55,3.08,1.72,4.79,.25,2.54,.4,6.43-.37,10.02",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M361.22,432.61s.43-3.62-2.13-5.54l-6.18-4.47",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M365.77,421.86l5.54,3.64c.92,.6,1.3,1.77,.91,2.79-.43,1.11-1.15,2.25-2.29,2l-2.2-5.38s-.61-1.45-1.96-3.05Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M167.59,260.95l1.01,15.7s1.07,15.77,25.57,22.16l-2.48-7.09c-.33-.93-.36-1.94-.09-2.88l3.7-13.17-27.7-14.7Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M209.51,303.92s-5.33,17.47-41.12,.21c0,0-20.86-10-41.68-8.49-5.89,.43-11.53,2.42-16.54,5.56-2.45,1.53-5.48,2.34-6.56-1.97,0,0-8.47-23.47,14.83-34.58,2.09-1,3.92-2.46,5.44-4.21,1.64-1.89,4.98-4.39,11.69-5.95l23.44-4.26,5.04,1.75s.61,5.2,3.54,8.97l1.01,15.7s1.28,15.98,25.57,22.16c0,0,4.69,2.13,7.03,4.05,0,0,3.41,2.56,8.31,1.07Z",
    fill: "#243E59",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 163.49,
    y: 195.04,
    width: 59.23,
    height: 80.75,
    rx: 29.62,
    ry: 29.62,
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M177.18,271.13c-1.22,6.63-9.02,12.05-14.23,7.78-.35-.29-.68-.6-.99-.93,0,0-12.12,6.57-15.66-1.52,0,0-18.18,4.55-20.71-7.58,0,0-13.64,2.02-18.69-18.69,0,0,4.55-2.53,6.06-10.1,0,0-.51-7.58,7.07-8.08,0,0,8.08,0,10.1-12.12,2.02-12.12,4.04-15.15,11.62-15.66,0,0,.95,1.01,4.49-7.07,0,0,5.56-10.1,14.65-9.09,0,0,5.05,0,7.07-3.03,0,0,8.08-8.59,19.19,2.53,0,0,13.13-7.31,24.55,9.31,.82,1.2,1.98,3.27,2.54,4.61,.62,1.47,2.2,4.02,6.19,6.34,0,0,9.15,4.49,6.12,17.12-3.03,12.63,5.05,11.11,5.05,11.11,0,0,7.58-1.01,6.06,8.08,0,0-1.52,8.08,2.53,11.11,0,0-8.59,11.62-15.15,7.58,0,0-4.56,21.14-21.73,15.59l-7.88-2.77s24.5-1.07,27.49-28.13v-20.88c0-10.65-3.27-15.51-7.2-19.31-3.38-3.28-8.19-4.75-12.77-3.65-2.61,.62-4.92,1.99-4.92,4.86,0,0,0,9.6-8.59,12.63,0,0-6.57,2.53-6.57,8.08,0,0,.06,1.52-.53,3.36,0,0-3.87,11.2-18.72,7.52l-.12,6.06c.04,2.71,.48,8.09,3.59,13.91,3.28,6.12,7.82,9.54,10.1,11.04Z",
    fill: "#231f20",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.19,
    cy: 234.35,
    rx: 6.71,
    ry: 10.55,
    transform: "translate(-20.54 15.45) rotate(-5.19)",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M313.06,310.74s6.39-4.05,16.62,3.62l7.24,7.46s5.97,4.26,3.2,10.44c0,0-1.92,6.18-6.18,5.97,0,0-2.13,3.2-4.05,4.47l-9.59-16.83s-3.65,1.12-4.05-4.9l-.21-3.62-2.98-6.61Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M320.31,325.87s3.92,0,4.61-4.28c.17-1.04,.08-2.1-.2-3.11l-1.43-5.18",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5,331.25s5.11,.8,6.39-5.17c0,0,.43-4.26,.21-8.95",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M327.77,338.85s1.49,.01,4.05-5.1l3.41-7.24",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M333.94,338.22s-2.38,.27-3.41-1.91",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M136,524.87c-61.67-31.85-75.96-64.06-79.2-78.82-1.01-4.58-.27-9.37,2.02-13.47,25.83-46.24,37.13-91.81,37.13-91.81,5.54-28.55,14.23-39.58,14.23-39.58,0,0,15.25-12.25,48.11-1.04,7.88,2.69,15.1,7.03,21.08,12.82,7.58,7.32,16.35,18.76,16.71,32.71,0,0-3.2,45.17-20.45,91.83l-39.63,87.36Z",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M133.07,307.38c-11.09,2.13-19.01,12.12-18.26,23.39,.71,10.58,7.09,24.24,29.08,37.5l46.88,31.32s12.71,7.7,23.04,7.01c2.12-.14,4.26,.08,6.28,.74l63.37,20.58,8.31-27.06s-35.74-13.9-58.23-25.22c-4.26-2.14-7.84-5.38-10.5-9.34-2.23-3.32-6.62-7.82-15.22-11.89l-15.51-14.15c-2.26-2.06-4.26-4.41-5.92-6.98-5.73-8.91-23.56-31.63-53.32-25.91Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.57,400.06c-.52,0-1.02-.3-1.26-.8l-4.89-10.54c-.32-.69-.02-1.52,.67-1.84,.69-.32,1.52-.02,1.84,.67l4.89,10.54c.32,.69,.02,1.52-.67,1.84-.19,.09-.39,.13-.58,.13Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.4,390.32s3.37-15.22-14.62-16.08c0,0-3.95-10.29-17.96-8.76-14.02,1.53-14.99,19.66-29.31,16.58,0,0,8.64,18.38,32.26,15.35,0,0,11.1-2.89,14.6-5.72,3.5-2.83,14.33-3.56,15.03-1.37Z",
    fill: "#7cd093",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.82,365.48c-14.02,1.53-14.99,19.66-29.31,16.58,0,0,.18,.37,.53,.98,9.1,9.83,19.48,8.22,28.6-.26,9.12-8.48,18.14-8.55,18.14-8.55,0,0-3.95-10.29-17.96-8.76Z",
    fill: "#7cd093",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M323.47,331.25s-2.86,1.95-2.34,5.47c.09,.62,.43,1.17,.92,1.54,1.15,.87,4.62,2.57,7.17-.41",
    fill: "#EC1C24",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.44,533.36h159.82s-14.78-16.51-28.83-10.89c0,0-9.54-14.05-25.49-12.64,0,0-28.59-16.51-49.31,3.51l-6.32,5.05s-15.1-8.57-27.39,5.48c0,0-18.96-2.11-22.48,9.48Z",
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.84,
    cy: 510.57,
    r: 1.76,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.19,518.04c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01,.45-1.01,1.01-1.01,1.01,.45,1.01,1.01Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.5,510c0,.87-.71,1.58-1.58,1.58s-1.58-.71-1.58-1.58,.71-1.58,1.58-1.58,1.58,.71,1.58,1.58Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592.44,
    cy: 522.12,
    r: 2.11,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.87,516.82c0,.47-.38,.84-.84,.84s-.84-.38-.84-.84,.38-.84,.84-.84,.84,.38,.84,.84Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.14,
    cy: 522.3,
    r: 1.4,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.9,524.63c0,.51-.41,.92-.92,.92s-.92-.41-.92-.92,.41-.92,.92-.92,.92,.41,.92,.92Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M229.62,583.43h159.82s-14.78-16.51-28.83-10.89c0,0-9.54-14.05-25.49-12.64,0,0-28.59-16.51-49.31,3.51l-6.32,5.05s-15.1-8.57-27.39,5.48c0,0-18.96-2.11-22.48,9.48Z",
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.02,
    cy: 560.64,
    r: 1.76,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.38,568.11c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01,.45-1.01,1.01-1.01,1.01,.45,1.01,1.01Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.69,560.07c0,.87-.71,1.58-1.58,1.58s-1.58-.71-1.58-1.58,.71-1.58,1.58-1.58,1.58,.71,1.58,1.58Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.62,
    cy: 572.19,
    r: 2.11,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,566.89c0,.47-.38,.84-.84,.84s-.84-.38-.84-.84,.38-.84,.84-.84,.84,.38,.84,.84Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.32,
    cy: 572.37,
    r: 1.4,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08,574.7c0,.51-.41,.92-.92,.92s-.92-.41-.92-.92,.41-.92,.92-.92,.92,.41,.92,.92Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M649.58,509.28h159.82s-14.78-16.51-28.83-10.89c0,0-9.54-14.05-25.49-12.64,0,0-28.59-16.51-49.31,3.51l-6.32,5.05s-15.1-8.57-27.39,5.48c0,0-18.96-2.11-22.48,9.48Z",
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722.98,
    cy: 486.5,
    r: 1.76,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.33,493.96c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01,.45-1.01,1.01-1.01,1.01,.45,1.01,1.01Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.64,485.93c0,.87-.71,1.58-1.58,1.58s-1.58-.71-1.58-1.58,.71-1.58,1.58-1.58,1.58,.71,1.58,1.58Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.58,
    cy: 498.05,
    r: 2.11,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.01,492.74c0,.47-.38,.84-.84,.84s-.84-.38-.84-.84,.38-.84,.84-.84,.84,.38,.84,.84Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.28,
    cy: 498.22,
    r: 1.4,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.04,500.55c0,.51-.41,.92-.92,.92s-.92-.41-.92-.92,.41-.92,.92-.92,.92,.41,.92,.92Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteer);
export default __webpack_public_path__ + "static/media/volunteer.ee64000932f69423da51d2d88fdc4f2b.svg";
export { ForwardRef as ReactComponent };